export const themeTitle = 'Cybros.Dev';

export const sections = [
  { title: 'Home', url: '#home' },
  { title: 'About', url: '#about' },
  { title: 'Services', url: '#services' },
  { title: 'Portfolio', url: '#portfolio' },
  { title: 'Testimonials', url: '#testimonial' },
  { title: 'Contact Us', url: '#contact', type: 'btn', className: 'MuiButton-contained MuiButton-containedPrimary MuiButton-root' },
];
export const mainBanner = {
  title: 'AI-Powered Software Solutions',
  descriptionTitle: 'Engineering Innovation for Tomorrow',
  descriptionsServices: ['Intelligent Web Applications', 'AI and Machine Learning Solutions', 'Enterprise Software Development', 'Scalable Cloud Architecture'],
};
export const services = [
  { 
    title: 'AI & Machine Learning', 
    img: 'web.jpg', 
    description: 'Custom AI models, NLP, computer vision, and predictive analytics solutions',
    details: 'We build intelligent systems that transform your business operations. Our AI solutions include custom <strong>Machine Learning</strong> models, <strong>Natural Language Processing (NLP)</strong> for chatbots and document analysis, <strong>Computer Vision</strong> for image recognition and automation, and <strong>Predictive Analytics</strong> to forecast trends and optimize decision-making. From proof-of-concept to production deployment, we deliver AI that drives real business value.'
  },
  { 
    title: 'Full-Stack Development', 
    img: 'security.jpg', 
    description: 'Scalable web applications with modern frameworks and cloud infrastructure',
    details: 'We craft robust, scalable web applications using cutting-edge technologies. Our full-stack expertise spans <strong>React</strong>, <strong>Vue</strong>, <strong>Angular</strong> on the frontend, and <strong>Node.js</strong>, <strong>Python</strong>, <strong>Ruby on Rails</strong>, <strong>Laravel</strong> on the backend. We implement secure authentication, real-time features, payment integrations, and optimize for performance. Every application is built with clean architecture, comprehensive testing, and deployment-ready infrastructure.'
  },
  {
    title: 'Enterprise Solutions',
    img: 'AutomationTestingProcess-1.png',
    description: 'Business automation, ERP integration, and workflow optimization',
    details: 'We streamline complex business operations with tailored enterprise solutions. Our services include custom <strong>ERP</strong> development and integration, <strong>Workflow Automation</strong> that eliminates manual processes, <strong>CRM</strong> customization, <strong>Inventory Management</strong> systems, and <strong>Business Intelligence</strong> dashboards. We help organizations reduce operational costs, improve efficiency, and gain actionable insights from their data.',
    link: 'https://cybroscloud.com/',
    isExternal: true
  },
  { 
    title: 'Cloud & DevOps', 
    img: 'responsive-design.jpg', 
    description: 'AWS, Azure, GCP deployment with CI/CD and infrastructure as code',
    details: 'We architect and manage cloud infrastructure that scales with your business. Our DevOps expertise includes <strong>AWS</strong>, <strong>Azure</strong>, and <strong>Google Cloud Platform</strong> deployments, containerization with <strong>Docker</strong> and <strong>Kubernetes</strong>, CI/CD pipeline setup with <strong>GitHub Actions</strong> and <strong>Jenkins</strong>, infrastructure as code using <strong>Terraform</strong>, and 24/7 monitoring with automated alerting. We ensure your applications are secure, highly available, and cost-optimized.'
  },
  { 
    title: 'API Development', 
    img: 'write.jpg', 
    description: 'RESTful & GraphQL APIs with robust security and documentation',
    details: 'We design and build APIs that power modern applications. Our API development includes <strong>RESTful</strong> and <strong>GraphQL</strong> architectures, <strong>OAuth 2.0</strong> and <strong>JWT</strong> authentication, rate limiting and caching strategies, comprehensive API documentation with <strong>Swagger/OpenAPI</strong>, and third-party integrations with payment gateways, social platforms, and enterprise systems. We ensure your APIs are secure, performant, and developer-friendly.'
  },
  { 
    title: 'Mobile Applications', 
    img: 'applications.png', 
    description: 'Cross-platform mobile apps with React Native and Flutter',
    details: 'We develop native-quality mobile applications for <strong>iOS</strong> and <strong>Android</strong>. Using <strong>React Native</strong> and <strong>Flutter</strong>, we build cross-platform apps that share code while delivering native performance. Our mobile solutions include offline-first architecture, push notifications, in-app purchases, biometric authentication, and seamless backend integration. From consumer apps to enterprise mobility solutions, we bring your mobile vision to life.'
  },
  { 
    title: 'Digital Media Services', 
    img: 'webdesign.jpg', 
    description: 'Video production, graphic design, content writing, and more creative solutions',
    details: 'We offer comprehensive digital media solutions to elevate your brand. Our services span <strong>Video Production & Editing</strong> (corporate videos, animations, reels), <strong>Graphic Design & Branding</strong> (logos, UI/UX design, infographics), <strong>Content Writing & Copywriting</strong> (SEO blogs, website copy, ad copy), <strong>Audio & Podcasting</strong> (podcast production, voiceovers, sound design), <strong>Social Media Management</strong> (platform management, content strategy, community engagement), <strong>Digital Marketing & Advertising</strong> (SEO, PPC, social media ads, CRO), and <strong>Web & Interactive Media</strong> (website design, interactive content, AR/VR). All delivered with modern design principles and strategic thinking.',
    isDigitalMedia: true,
    link: '/digital-media-services'
  },
];
export const technologies = [
  { title: 'Rails', img: 'rails.png' },
  { title: 'DJango', img: 'django.svg' },
  { title: 'React-JS', img: 'react.svg' },
  { title: 'WordPress', img: 'wordpress.svg' },
  { title: 'Laravel', img: 'laravel.min.svg' },
  // { title: 'GraphQL', img: 'gql.svg' },
  { title: 'Material-UI', img: 'material.svg' },
  { title: 'Node-JS', img: 'nodejs.png' },
  { title: 'VUE', img: 'vue.jpg' },
  { title: 'Storybook', img: 'storybook.png' },
  // { title: "PHP", img: "php-logo.png" },
  { title: 'Bootstrap', img: 'bootstrap-logo.png' },
  { title: 'Automation', img: 'testcafe.png' },
  // { title: "GIT", img: "git.png" },
  { title: 'SEO', img: 'seo.svg' },
  // { title: "HTML5", img: "html5.png" },
  { title: 'Shopify', img: 'shopify.svg' },
];
export const digitalMediaServices = [
  {
    category: 'Video Production & Editing',
    icon: '🎬',
    services: [
      {
        title: 'Corporate Promotional Videos',
        description: 'Highlighting company culture, products, or services.',
        deliverables: ['Script development', 'Professional filming', 'Editing & color correction', 'Music & SFX'],
        tools: ['Premiere Pro', 'After Effects', 'DaVinci Resolve'],
        pricing: 'Starting from $2,500',
        estimatedTime: '2-3 weeks'
      },
      {
        title: 'Explainer & Animated Videos',
        description: '2D/3D animation, whiteboard animation, or motion graphics to explain complex concepts.',
        deliverables: ['Concept & storyboarding', '2D/3D animation', 'Voice-over & music', 'Delivery in multiple formats'],
        tools: ['After Effects', 'Cinema 4D', 'Blender', 'Adobe Animate'],
        pricing: 'Starting from $3,500',
        estimatedTime: '3-4 weeks'
      },
      {
        title: 'Social Media Video Reels',
        description: 'Short-form, engaging content optimized for TikTok, Instagram Reels, and YouTube Shorts.',
        deliverables: ['Trend-based content', 'Mobile-optimized editing', 'Multiple formats', 'Hashtag strategy'],
        tools: ['CapCut', 'Premiere Pro', 'Adobe Premiere Rush'],
        pricing: 'Starting from $800 per reel',
        estimatedTime: '3-5 days'
      },
      {
        title: 'Webinar & Live Event Broadcasting',
        description: 'Live streaming setup, recording, and post-event editing.',
        deliverables: ['Live stream setup', 'Multi-camera coverage', 'Recording & editing', 'Archival & distribution'],
        tools: ['OBS Studio', 'Wirecast', 'Streamyard'],
        pricing: 'Starting from $1,500',
        estimatedTime: 'Based on event date'
      },
      {
        title: 'Video Testimonials & Case Studies',
        description: 'Interview-style videos featuring satisfied clients.',
        deliverables: ['Interview filming', 'Editing & graphics', 'Subtitles', 'Multiple cuts'],
        tools: ['Premiere Pro', 'Final Cut Pro', 'DaVinci Resolve'],
        pricing: 'Starting from $1,200',
        estimatedTime: '1-2 weeks'
      },
      {
        title: 'Post-Production Services',
        description: 'Color correction, audio syncing, VFX, and subtitling/closed captioning.',
        deliverables: ['Color grading', 'Audio mixing', 'VFX & transitions', 'Subtitles & CC'],
        tools: ['DaVinci Resolve', 'Audition', 'Fusion'],
        pricing: 'Starting from $600',
        estimatedTime: 'Per project basis'
      }
    ]
  },
  {
    category: 'Audio & Podcasting Services',
    icon: '🎙️',
    services: [
      {
        title: 'Podcast Production & Launch',
        description: 'Concept development, recording setup, and distribution to platforms (Spotify, Apple Podcasts).',
        deliverables: ['Concept development', 'Recording studio setup', 'Episode editing', 'Distribution setup'],
        tools: ['Audacity', 'Adobe Audition', 'Anchor', 'Podbean'],
        pricing: 'Starting from $2,000/month',
        estimatedTime: 'Ongoing'
      },
      {
        title: 'Audio Editing & Mixing',
        description: 'Removing background noise, adding intros/outros, and leveling audio.',
        deliverables: ['Noise removal', 'Audio normalization', 'Intro/outro production', 'Final master'],
        tools: ['Adobe Audition', 'Audacity', 'Pro Tools'],
        pricing: 'Starting from $300/hour',
        estimatedTime: 'Per project'
      },
      {
        title: 'Voiceover Services',
        description: 'Professional voice acting for commercials, audiobooks, and IVR systems.',
        deliverables: ['Professional narration', 'Multiple takes', 'Edited delivery', 'Commercial licenses'],
        tools: ['Audacity', 'Adobe Audition', 'Voiceover Pro'],
        pricing: 'Starting from $250',
        estimatedTime: '2-3 days'
      },
      {
        title: 'Custom Sound Design & Music',
        description: 'Creating original jingles, intro music, or sound effects.',
        deliverables: ['Original composition', 'Multiple versions', 'Commercial license', 'Source files'],
        tools: ['FL Studio', 'Ableton Live', 'Logic Pro'],
        pricing: 'Starting from $500',
        estimatedTime: '1-2 weeks'
      }
    ]
  },
  {
    category: 'Graphic Design & Branding',
    icon: '🎨',
    services: [
      {
        title: 'Brand Identity Packages',
        description: 'Logo design, brand guidelines, color palettes, and typography.',
        deliverables: ['Logo design (3-5 variations)', 'Brand guidelines', 'Color palette', 'Typography system'],
        tools: ['Adobe Illustrator', 'Figma', 'Adobe XD'],
        pricing: 'Starting from $1,500',
        estimatedTime: '2-3 weeks'
      },
      {
        title: 'Digital Marketing Assets',
        description: 'Design for display ads, social media banners, and email newsletter templates.',
        deliverables: ['Display ads (multiple sizes)', 'Social media templates', 'Email templates', 'Web banners'],
        tools: ['Adobe Photoshop', 'Figma', 'Canva Pro'],
        pricing: 'Starting from $1,200',
        estimatedTime: '1-2 weeks'
      },
      {
        title: 'Presentation Design',
        description: 'Professional PowerPoint or Keynote pitch decks.',
        deliverables: ['Slide design', 'Brand-aligned templates', 'Speaker notes', 'Animated transitions'],
        tools: ['Adobe XD', 'Figma', 'Keynote'],
        pricing: 'Starting from $800',
        estimatedTime: '1 week'
      },
      {
        title: 'Infographics',
        description: 'Transforming complex data into visually appealing, shareable graphics.',
        deliverables: ['Data visualization', 'Icon design', 'Multiple formats', 'Source files'],
        tools: ['Adobe Illustrator', 'Figma', 'Piktochart'],
        pricing: 'Starting from $600',
        estimatedTime: '3-5 days'
      },
      {
        title: 'UI/UX Prototyping',
        description: 'Wireframing and designing user interfaces for apps or websites.',
        deliverables: ['Wireframes', 'UI mockups', 'Prototype', 'Design system'],
        tools: ['Figma', 'Adobe XD', 'Framer'],
        pricing: 'Starting from $2,000',
        estimatedTime: '2-4 weeks'
      }
    ]
  },
  {
    category: 'Content Writing & Copywriting',
    icon: '✍️',
    services: [
      {
        title: 'SEO Blog Posts & Articles',
        description: 'Keyword-optimized content to drive organic traffic.',
        deliverables: ['Keyword research', 'Article writing', 'SEO optimization', 'Meta descriptions'],
        tools: ['SEMrush', 'Ahrefs', 'Grammarly', 'Surfer SEO'],
        pricing: 'Starting from $150/article',
        estimatedTime: '3-5 days'
      },
      {
        title: 'Website Copywriting',
        description: 'Landing page copy, "About Us" pages, and product descriptions.',
        deliverables: ['Landing page copy', 'Homepage copy', 'Product descriptions', 'Conversion optimization'],
        tools: ['Figma', 'Grammarly', 'Hemingway Editor'],
        pricing: 'Starting from $1,000',
        estimatedTime: '1-2 weeks'
      },
      {
        title: 'Email Marketing Campaigns',
        description: 'Drip campaigns, newsletters, and promotional blasts.',
        deliverables: ['Campaign strategy', 'Email templates', 'Copy writing', 'Performance tracking'],
        tools: ['Mailchimp', 'ConvertKit', 'HubSpot'],
        pricing: 'Starting from $500',
        estimatedTime: 'Ongoing'
      },
      {
        title: 'Ad Copy',
        description: 'Persuasive short-form copy for Google Ads, Facebook Ads, and LinkedIn.',
        deliverables: ['Ad variations', 'Headlines & descriptions', 'CTA optimization', 'A/B testing'],
        tools: ['Google Ads', 'Grammarly', 'Copyhackers'],
        pricing: 'Starting from $400',
        estimatedTime: '1 week'
      },
      {
        title: 'E-books & Whitepapers',
        description: 'Long-form, downloadable lead magnets.',
        deliverables: ['Research & writing', 'Design & layout', 'PDF formatting', 'Distribution setup'],
        tools: ['Google Docs', 'Figma', 'Grammarly'],
        pricing: 'Starting from $2,000',
        estimatedTime: '3-4 weeks'
      }
    ]
  },
  {
    category: 'Social Media Management',
    icon: '📱',
    services: [
      {
        title: 'Platform Management',
        description: 'Full-service management of Facebook, X (formerly Twitter), LinkedIn, Instagram, etc.',
        deliverables: ['Daily posting', 'Community engagement', 'Content strategy', 'Monthly reports'],
        tools: ['Buffer', 'Hootsuite', 'Later', 'Sprout Social'],
        pricing: 'Starting from $800/month',
        estimatedTime: 'Ongoing'
      },
      {
        title: 'Content Calendar Creation',
        description: 'Planning out a month-by-month grid of posts and campaigns.',
        deliverables: ['Content strategy', 'Monthly calendar', 'Post templates', 'Promotional planning'],
        tools: ['Asana', 'Monday.com', 'Trello'],
        pricing: 'Starting from $300/month',
        estimatedTime: 'Monthly'
      },
      {
        title: 'Community Management',
        description: 'Responding to comments, messages, and engaging with followers.',
        deliverables: ['Comment responses', 'DM management', 'Engagement tracking', 'Sentiment analysis'],
        tools: ['Hootsuite', 'Sprout Social', 'Mention'],
        pricing: 'Starting from $500/month',
        estimatedTime: 'Ongoing'
      },
      {
        title: 'Social Listening & Analytics',
        description: 'Tracking brand mentions and providing monthly performance reports.',
        deliverables: ['Trend monitoring', 'Competitor analysis', 'Monthly reports', 'Insights & recommendations'],
        tools: ['Brandwatch', 'Mention', 'Hootsuite Insights'],
        pricing: 'Starting from $400/month',
        estimatedTime: 'Ongoing'
      }
    ]
  },
  {
    category: 'Digital Marketing & Advertising',
    icon: '📊',
    services: [
      {
        title: 'Search Engine Optimization (SEO)',
        description: 'On-page, off-page, and technical SEO audits and implementation.',
        deliverables: ['SEO audit', 'Keyword strategy', 'On-page optimization', 'Link building'],
        tools: ['SEMrush', 'Ahrefs', 'Screaming Frog', 'Google Analytics'],
        pricing: 'Starting from $1,200/month',
        estimatedTime: 'Ongoing (3-6 months for results)'
      },
      {
        title: 'Pay-Per-Click (PPC) Management',
        description: 'Google Ads and Bing Ads campaign setup and optimization.',
        deliverables: ['Campaign setup', 'Keyword bidding', 'Ad optimization', 'Monthly reporting'],
        tools: ['Google Ads', 'Bing Ads', 'SEMrush', 'Optmyzr'],
        pricing: 'Starting from $800/month + ad spend',
        estimatedTime: 'Ongoing'
      },
      {
        title: 'Social Media Advertising',
        description: 'Targeted ad campaigns on Meta, LinkedIn, and TikTok.',
        deliverables: ['Campaign strategy', 'Ad design', 'Audience targeting', 'Performance optimization'],
        tools: ['Facebook Ads Manager', 'Meta Business Suite', 'TikTok Ads Manager'],
        pricing: 'Starting from $600/month + ad spend',
        estimatedTime: 'Ongoing'
      },
      {
        title: 'Conversion Rate Optimization (CRO)',
        description: 'A/B testing landing pages to improve sales or lead capture.',
        deliverables: ['Landing page audit', 'A/B testing', 'Heat mapping', 'Conversion improvements'],
        tools: ['Optimizely', 'Unbounce', 'Hotjar', 'Google Analytics'],
        pricing: 'Starting from $1,500',
        estimatedTime: '2-4 weeks'
      }
    ]
  },
  {
    category: 'Web & Interactive Media',
    icon: '🌐',
    services: [
      {
        title: 'Website Design & Development',
        description: 'Building custom sites on WordPress, Shopify, Webflow, etc.',
        deliverables: ['Custom design', 'Responsive development', 'SEO setup', 'Performance optimization'],
        tools: ['Webflow', 'WordPress', 'Shopify', 'Figma'],
        pricing: 'Starting from $2,500',
        estimatedTime: '3-6 weeks'
      },
      {
        title: 'Interactive Content',
        description: 'Quizzes, calculators, and interactive maps.',
        deliverables: ['Concept design', 'Development', 'Integration', 'Analytics setup'],
        tools: ['React', 'Vue.js', 'Figma', 'Three.js'],
        pricing: 'Starting from $1,500',
        estimatedTime: '2-3 weeks'
      },
      {
        title: 'AR/VR Experiences',
        description: 'Basic augmented reality filters for social media or virtual 360-degree tours.',
        deliverables: ['Experience design', 'AR/VR development', 'Testing & optimization', 'Deployment'],
        tools: ['Unity', 'Unreal Engine', '8th Wall', 'ZapWorks'],
        pricing: 'Starting from $3,000',
        estimatedTime: '4-6 weeks'
      }
    ]
  }
];

export const portfolioItems = [
  {
    title: 'ELT Cloud',
    logo: 'eltcloud.svg',
    // link: "https://eltcloud.com",
  },
  {
    title: 'Student Information System',
    logo: 'sis.svg',
    // link: "https://client1.xnrel.ca",
  },
  {
    title: 'Fly',
    logo: 'fly.svg',
    // link: "https://dev.fly.me/",
  },
  {
    title: 'JESS',
    logo: 'jess.png',
    // link: "https://getjess.com/",
  },
  {
    title: 'Trip Buddy App',
    logo: 'tripbuddyapp.png',
    // link: "https://www.thetripbuddyapp.com/",
  },
  {
    title: 'Digital Art',
    logo: 'digiart.png',
    // link: "https://digiart.company",
  },
  {
    title: 'Umbrella',
    logo: 'umbrella_logo_white_letters_small_blue.png',
    // link: "https://www.umbrellaus.com/",
  },
  {
    title: 'AlPrints',
    logo: 'alprints.png',
    // link: "https://alprints.com/",
  },
  {
    title: 'Doc Wizard',
    logo: 'doc-wizard.png',
    // link: "https://nodomainyet.com/",
  },
  {
    title: 'get a room',
    logo: 'getaroom.svg',
    // link: "https://getaroom.com/",
  },
  {
    title: 'get a room',
    logo: 'intimely.webp',
  },
  {
    title: 'Supernova Brands',
    logo: 'supernoval-logo.png',
    link: 'https://supernovabrands.com',
  },
  {
    title: 'Lune Stelle Brands',
    logo: 'estrella-logo.avif',
    link: 'https://lunestelle.com/',
  },
  {
    title: 'Ajeeth Labs',
    logo: 'ajeeth.png',
    // link: 'https://lunestelle.com/',
  },
  {
    title: 'Ajeeth Labs',
    logo: 'testsInc.png',
    // link: 'https://lunestelle.com/',
  },
  {
    title: 'Morph',
    logo: 'morph.svg',
    // link: 'https://lunestelle.com/',
  },
];
